import { useState } from 'react';
import Button from '../ui/Button';
import { EditRequestModal, PendingEditBanner } from './StepEditRequest';
import { usePermission } from '../../auth/usePermission';

/**
 * Completed TASK steps only (decision outcomes — approve/reject/pass/fail — are final and not
 * covered by this). Lets a user with 'edit candidate completed step' propose a change to the
 * step's checklist/fields/remarks, and a *different* user with 'approve edit candidate
 * completed step' approve or reject it — nothing on the step changes until approved.
 */
export default function CompletedStepEditPanel({ candidate, step }) {
  const { can } = usePermission();
  const [editOpen, setEditOpen] = useState(false);

  if (step.kind !== 'task' || step.status !== 'completed') return null;

  return (
    <div className="mt-3">
      <PendingEditBanner candidate={candidate} step={step} />

      {!step.pending_edit_request && can('edit candidate completed step') && (
        <Button variant="secondary" onClick={() => setEditOpen(true)}>
          Edit
        </Button>
      )}

      <EditRequestModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        candidate={candidate}
        step={step}
        fields={step.fields || []}
        sections={step.field_sections || []}
      />
    </div>
  );
}
